import { z } from "zod";
import {
  createFormSchema,
  emailSchema,
  passwordSchema,
  phoneSchema,
  nameSchema,
  zipCodeSchema,
} from "./generalValidation";
import { CREATE_CPA_SCHEMA } from "../schemas/accounts/createCpaSchema";

const getCreateCpaSchemas = () => {
  return createFormSchema(CREATE_CPA_SCHEMA);
};

export { getCreateCpaSchemas };
export default getCreateCpaSchemas;

// Account domain-specific schemas (moved from core)
export const personalInfoSchema = z.object({
  firstname: nameSchema,
  lastname: nameSchema,
  email: emailSchema,
  dateBirth: z.string().min(1, "Date of birth is required"),
  phoneNumber: phoneSchema,
  password: passwordSchema,
  confirm_password: passwordSchema,
});

export const personalAddressSchema = z.object({
  street: z.string().min(1, "Street address is required"),
  apt: z.string().optional(),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  zipCode: zipCodeSchema,
});

export const licenseAgreementsSchema = z.object({
  license_type: z.string().min(1, "License type is required"),
});

export const schemasBySection = {
  Personal_Info: personalInfoSchema,
  Personal_Address: personalAddressSchema,
  License_Agreements: licenseAgreementsSchema,
};

export const getFieldsForSection = (sectionName) => {
  const sectionSchemas = {
    Personal_Info: [
      "firstname",
      "lastname",
      "email",
      "dateBirth",
      "phoneNumber",
      "password",
      "confirm_password",
    ],
    Personal_Address: ["street", "apt", "city", "state", "zipCode"],
    License_Agreements: ["license_type"],
  };

  return sectionSchemas[sectionName] || [];
};
